module.exports = __webpack_public_path__ + "img/item-number.7ba26e44.png";